/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var CopyFillIcon = function CopyFillIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3C4.79086 3 3 4.79086 3 7V16H5V7C5 5.89543 5.89543 5 7 5H16V3H7ZM7 10C7 8.34315 8.34315 7 10 7H18C19.6569 7 21 8.34315 21 10V18C21 19.6569 19.6569 21 18 21H10C8.34315 21 7 19.6569 7 18V10Z"
  }));
};
export default CopyFillIcon;